import API from "../../../common/utils/API";
import {displayDuplicateMessage, displayErrorMessage} from "../../../common/marvel-reducers/formMessageActions";
import {closeAddEditModal} from "../../../veritas/add-edit/actions/AddEditActions";
import {activityLoggerActionTypes} from "../constants/UtilityMiddlewareConstants";
import {apiActionsDP} from "../constants/ApiMiddlewareConstants";
import {
    fetchAllOrganizations,
    fetchOneDataProviderSuccess,
    getAllOrganizationsSuccess, toggleDeleteWarning, updateDPListFilters
} from "../../../veritas/data-providers/actions/DataProviderActions";
import MARVEL from "../../../common/utils/MarvelUrls";
import { setRouterLink } from "../../../router/RouterActions";
import {updatedDPRefresh} from "../../../veritas/add-edit/actions/AddEditDPActions";
import {toUpperCaseSentence} from "../../../common/utils/ToUpperCaseSentence";

/**
 * This is the Middleware to handle the API calls pertaining to
 * Data Providers. (Currently, only contains logic for post
 * and put... rest will be added subsequently.)
 * @param store, action
 * @returns Makes the API call and conditionally dispatches logger actions or
 * error or warning messages.
 */
const apiMiddlewareDataProvider = (store) => (next) => (action) => {

    switch (action.type) {

        case apiActionsDP.GET: {
            next(action);

            const {providerID, authToken} = action.payload;
            API.getOneDataProvider(providerID, authToken.idToken)
                .then(resDP => {
                    store.dispatch(fetchOneDataProviderSuccess(
                        resDP.data,
                    ));
                })
                .catch(err => {
                    console.error(err);
                    throw new err();
                })
            break;
        }

        case apiActionsDP.POST: {
            next(action);
            const { providerObject, authToken } = action.payload;

            API.postDataProvider(providerObject, authToken.idToken)
                .then(res => {
                    const log = {
                        object_id: res.data.provider_id,
                        object_type: "data_provider_create",
                        user: authToken.account.name
                    };
                    store.dispatch({
                        type: activityLoggerActionTypes.LOG_CHANGE,
                        payload: { log, authToken }
                    });
                    store.dispatch(closeAddEditModal("Data Provider"));
                    // action to update the redux object holding the DPs.
                    store.dispatch(fetchAllOrganizations());
                    store.dispatch(setRouterLink(MARVEL.VERITAS.data_providers + res.data.provider_id))

                }).catch(error => {
                    const errorObject = error.response.data
                    const message = [];
                    // pretty print the error message for the user
                    // eslint-disable-next-line no-unused-vars
                    for (let [key, value] of Object.entries(errorObject)) {
                        message.push(toUpperCaseSentence(value[0]));
                    }
                    if (errorObject['provider_name']) {
                        store.dispatch(displayDuplicateMessage(message, true));
                    } else {
                        store.dispatch(displayErrorMessage(message, true));
                    }
                });

            break;
        }

        case apiActionsDP.PUT: {
            const { dataProviderID, providerObject, authToken } = action.payload;

            API.updateDataProvider(dataProviderID, providerObject, authToken.idToken)
                .then(res => {
                    const log = {
                        object_id: dataProviderID,
                        object_type: "data_provider_edit",
                        user: authToken.account.name
                    };
                    store.dispatch({
                        type: activityLoggerActionTypes.LOG_CHANGE,
                        payload: { log, authToken }
                    });
                    store.dispatch(closeAddEditModal("Data Provider"));
                    store.dispatch(updatedDPRefresh());
                }).catch(error => {
                    const message = [];
                    const errorObject = error.response.data
                    // pretty print the error message for the user
                    // eslint-disable-next-line no-unused-vars
                    for (let [key, value] of Object.entries(errorObject)) {
                        message.push(toUpperCaseSentence(value[0]));
                    }
                    if (errorObject['provider_name']) {
                        store.dispatch(displayDuplicateMessage(message, true));
                    } else {
                        store.dispatch(displayErrorMessage(message, true));
                    }
            });
            break;
        }

        case apiActionsDP.GET_ALL_ORGANIZATIONS: {
            next(action);

            const { authToken } = action.payload;
            API.getAllOrganizations(authToken.idToken)
                .then(res => {
                    store.dispatch(getAllOrganizationsSuccess(res.data));
                    // to apply any previously set filters to the fetched providers
                    store.dispatch(updateDPListFilters());
                })
                .catch(error => console.error(error));

            break;
        }

        case apiActionsDP.DELETE_CURRENT_DATA_PROVIDER: {
            next(action);

            const {dpID, authToken} = action.payload;
            API.deleteDataProvider(dpID, authToken.idToken)
                .then(res => {
                    const log = {
                        object_id: dpID,
                        object_type: "data_provider_delete",
                        user: authToken.account.name
                    };
                    store.dispatch({
                        type: activityLoggerActionTypes.LOG_CHANGE,
                        payload: { log, authToken }
                    });
                    store.dispatch(toggleDeleteWarning());
                    store.dispatch(setRouterLink(MARVEL.VERITAS.data_providers))

                })
                .catch(error => console.error(error));
            break;
        }

        default: next(action);
    }
}

export default apiMiddlewareDataProvider;
